<div class="detail-page">

  <!-- Skeleton loading state (two-column mirroring the workspace) -->
  <div class="workspace-skeleton" *ngIf="loading">

    <!-- Left skeleton -->
    <div class="skeleton-col">
      <div class="sk-tabs-bar">
        <div class="sk-tab sk-tab--active">{{ 'permit.manage.detail.tab_infos' | translate }}</div>
        <div class="sk-tab">{{ 'permit.manage.detail.tab_messages' | translate }}</div>
      </div>
      <div class="sk-scroll">
        <div class="sk-header-card">
          <div class="sk-header-row">
            <app-skeleton-loader width="42px" height="42px" borderRadius="50%"></app-skeleton-loader>
            <div class="sk-text-column">
              <app-skeleton-loader width="58%" height="18px"></app-skeleton-loader>
              <app-skeleton-loader width="42%" height="15px"></app-skeleton-loader>
            </div>
            <app-skeleton-loader width="80px" height="26px" borderRadius="13px"></app-skeleton-loader>
          </div>
          <div class="sk-description-section">
            <app-skeleton-loader width="100%" height="14px"></app-skeleton-loader>
            <app-skeleton-loader width="100%" height="14px"></app-skeleton-loader>
            <app-skeleton-loader width="75%" height="14px"></app-skeleton-loader>
          </div>
        </div>
      </div>
    </div>

    <!-- Right skeleton -->
    <div class="skeleton-col skeleton-col-right">
      <div class="sk-panel-meta-row">
        <div class="sk-internal-badge">
          <mat-icon class="sk-lock-icon">lock</mat-icon>
          <span class="sk-banner-text">{{ 'permit.manage.detail.internal' | translate }}</span>
        </div>
        <div class="sk-panel-actions">
          <app-skeleton-loader width="28px" height="28px" borderRadius="6px"></app-skeleton-loader>
          <app-skeleton-loader width="28px" height="28px" borderRadius="6px"></app-skeleton-loader>
        </div>
      </div>
      <div class="sk-tabs-bar">
        <div class="sk-tab sk-tab--active">{{ 'permit.manage.detail.tab_management' | translate }}</div>
        <div class="sk-tab">{{ 'permit.manage.detail.tab_collaboration' | translate }}</div>
        <div class="sk-tab">{{ 'permit.manage.detail.tab_history' | translate }}</div>
      </div>
      <div class="sk-sections-list">
        <div class="sk-section-block">
          <div class="sk-section-header">
            <span class="sk-section-title">{{ 'permit.manage.tags.title' | translate }}</span>
          </div>
          <div class="sk-section-content sk-section-content--row">
            <app-skeleton-loader width="62px" height="26px" borderRadius="13px"></app-skeleton-loader>
            <app-skeleton-loader width="78px" height="26px" borderRadius="13px"></app-skeleton-loader>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Workspace: two-column layout -->
  <div class="workspace" *ngIf="!loading && permit">

    <!-- Left column: citizen-facing -->
    <div class="workspace-left">
      <app-permit-infos-panel
        [permit]="permit"
        (permitUpdated)="onPermitUpdated()">
      </app-permit-infos-panel>
    </div>

    <!-- Right column: internal -->
    <div class="workspace-right">
      <app-permit-internal-panel
        [permit]="permit"
        (permitUpdated)="onPermitUpdated()"
        (closed)="close()">
      </app-permit-internal-panel>
    </div>

  </div>

</div>
